import styled from '@emotion/styled';

const InlineLink = styled('a')(({ theme }) => ({
  color: `${theme.colors.blue.primary}!important`, // important to override "typeSecondary a for dialogs"
  cursor: 'pointer',
  transition: 'all 300ms ease-in-out',
}));

export default InlineLink;
